export const blogAppUrl = `${process.env.NEXT_PUBLIC_BLOG_PROTOCOL}://${process.env.NEXT_PUBLIC_BLOG_HOST}:${process.env.NEXT_PUBLIC_BLOG_PORT}`
export const getBlogUrl = (url: string) => `${blogAppUrl}${url}`
